import React, {useState} from "react"

const CAMERA_CENTER_INDEX = 0
const CAMERA_MAP_OFFSET_INDEX = 0 // with center camera 1
const CAMERA_INI_INDEX = 1

const CAMERA_COUNT = {
    rectangle: 4,
    open: 3,
    l_form_a: 6,
    l_form_b: 6,
    l_form_c: 6,
    l_form_d: 6,
    pentagonal_a: 5,
    pentagonal_b: 5,
    pentagonal_c: 5,
    pentagonal_d: 5,
}

const CAMERA_MAP = {
    rectangle: <>
        <path d="M 0,50 3,47 V 3 L 0,0 Z"/>
        <path d="M 0,0 H 50 L 47,3 H 3 Z"/>
        <path d="M 50,50 47,47 V 3 l 3,-3 z"/>
        <path d="M -4.9999999e-8,50 H 50 L 47,47 H 3 Z"/>
        <g>
            {/*<path d="m 25,28.5 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>*/}
            <path d="M 4.499999,28.5 C 2.578312,28.500001 1,26.921689 1,25 c 0,-1.921689 1.578312,-3.500001 3.499999,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 25,8 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 45.5,28.5 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 10e-7,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 25,49 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
        </g>
    </>,
    open: <>
        <path d="M 0,50 H 3 V 3 L 0,0 Z"/>
        <path d="M 0,0 H 50 L 47,3 H 3 Z"/>
        <path d="M 50,50 H 47 V 3 l 3,-3 z"/>
        <g>
            {/*<path d="m 25,48.5 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>*/}
            <path d="M 4.499999,28.5 C 2.578312,28.500001 1,26.921689 1,25 c 0,-1.921689 1.578312,-3.500001 3.499999,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 25,8 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 45.5,28.5 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 10e-7,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
        </g>
    </>,
    l_form_a: <>
        <path d="m 0,0 3,3 V 47 l -3,3 z"/>
        <path d="M 0,50 H 50 l -3,-3 H 3 Z"/>
        <path d="m 50,50 -3,-3 V 25 l 3,-3 z"/>
        <path d="m 25,25 3,-3 h 22 L 47,25 Z"/>
        <path d="M 28,0 25,3 V 25 l 3,-3 z"/>
        <path d="M 3,3 0,0 H 28 L 25,3 Z"/>
        <g>
            {/*<path d="m 14,32.5 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,10e-7 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>*/}
            <path d="M 4.499999,21.5 C 2.578312,21.499999 1,23.078311 1,25 c 0,1.921689 1.578312,3.500001 3.499999,3.5 1.921689,1e-6 3.5000006,-1.578311 3.4999996,-3.5 1e-6,-1.921689 -1.5783106,-3.500001 -3.4999996,-3.5 z"/>
            <path d="m 14,1 c -1.921688,-1e-6 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,10e-7 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 23.5,9 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,1e-6 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 37.5,23 c -1.921688,-1e-6 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,1e-6 3.500001,-1.578311 3.5,-3.5 10e-7,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 45.5,32.5 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,10e-7 3.500001,-1.578311 3.5,-3.5 10e-7,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 25,42 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,10e-7 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
        </g>
    </>,
    l_form_b: <>
        <path d="m 50,0 -3,3 v 44 l 3,3 z"/>
        <path d="M 50,50 H 0 l 3,-3 h 44 z"/>
        <path d="M 0,50 3,47 V 25 L 0,22 Z"/>
        <path d="M 25,25 22,22 H 0 l 3,3 z"/>
        <path d="m 22,0 3,3 v 22 l -3,-3 z"/>
        <path d="M 47,3 50,0 H 22 l 3,3 z"/>
        <g>
            {/*<path d="m 36,32.5 c 1.921688,-10e-7 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,10e-7 -3.500001,-1.578311 -3.5,-3.5 -10e-7,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>*/}
            <path d="M 4.5,32.5 C 6.421688,32.499999 8,34.078311 8,36 8,37.921689 6.421688,39.500001 4.5,39.5 2.578311,39.500001 0.999999,37.921689 1,36 c -1e-6,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 12.5,23 c 1.921688,-1e-6 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,1e-6 -3.500001,-1.578311 -3.5,-3.5 -10e-7,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 26.5,9 c 1.921688,-10e-7 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,1e-6 -3.500001,-1.578311 -3.5,-3.5 -1e-6,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 36,1 c 1.921688,-1e-6 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,10e-7 -3.500001,-1.578311 -3.5,-3.5 -10e-7,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="M 45.500001,21.5 C 47.421688,21.499999 49,23.078311 49,25 c 0,1.921689 -1.578312,3.500001 -3.499999,3.5 -1.921689,1e-6 -3.500001,-1.578311 -3.5,-3.5 -10e-7,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 25,42 c 1.921688,-10e-7 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,10e-7 -3.500001,-1.578311 -3.5,-3.5 -1e-6,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
        </g>
    </>,
    l_form_c: <>
        <path d="M 0,50 3,47 V 3 L 0,0 Z"/>
        <path d="M 0,0 H 50 L 47,3 H 3 Z"/>
        <path d="m 50,0 -3,3 v 22 l 3,3 z"/>
        <path d="m 25,25 3,3 h 22 l -3,-3 z"/>
        <path d="M 28,50 25,47 V 25 l 3,3 z"/>
        <path d="M 3,47 0,50 H 28 L 25,47 Z"/>
        <g>
            {/*<path d="m 14,17.5 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>*/}
            <path d="M 4.499999,28.5 C 2.578312,28.500001 1,26.921689 1,25 c 0,-1.921689 1.578312,-3.500001 3.499999,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 25,8 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 45.5,17.5 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 10e-7,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 37.5,27 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 10e-7,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 23.5,41 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 14,49 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
        </g>
    </>,
    l_form_d: <>
        <path d="M 50,50 47,47 V 3 l 3,-3 z"/>
        <path d="M 50,0 H 0 l 3,3 h 44 z"/>
        <path d="M 0,0 3,3 V 25 L 0,28 Z"/>
        <path d="m 25,25 -3,3 H 0 l 3,-3 z"/>
        <path d="m 22,50 3,-3 V 25 l -3,3 z"/>
        <path d="m 47,47 3,3 H 22 l 3,-3 z"/>
        <g>
            {/*<path d="m 36,17.5 c 1.921688,1e-6 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-10e-7 -3.500001,1.578311 -3.5,3.5 -10e-7,1.921689 1.578311,3.500001 3.5,3.5 z"/>*/}
            <path d="m 26.5,41 c 1.921688,10e-7 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-10e-7 -3.500001,1.578311 -3.5,3.5 -1e-6,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="m 12.5,27 c 1.921688,1e-6 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-1e-6 -3.500001,1.578311 -3.5,3.5 -10e-7,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="M 4.5,17.5 C 6.421688,17.500001 8,15.921689 8,14 8,12.078311 6.421688,10.499999 4.5,10.5 2.578311,10.499999 0.999999,12.078311 1,14 c -1e-6,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="m 25,8 c 1.921688,10e-7 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-1e-6 -3.500001,1.578311 -3.5,3.5 -1e-6,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="M 45.500001,28.5 C 47.421688,28.500001 49,26.921689 49,25 c 0,-1.921689 -1.578312,-3.500001 -3.499999,-3.5 -1.921689,-1e-6 -3.500001,1.578311 -3.5,3.5 -10e-7,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="m 36,49 c 1.921688,10e-7 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-10e-7 -3.500001,1.578311 -3.5,3.5 -10e-7,1.921689 1.578311,3.500001 3.5,3.5 z"/>
        </g>
    </>,

    pentagonal_a: <>
        <path d="m 0,0 3,3 V 47 l -3,3 z"/>
        <path d="M 0,50 H 50 l -3,-3 H 3 Z"/>
        <path d="M 50,50 47,47 V 23.888889 L 50,22 Z"/>
        <path d="M 26.111111,3 47,23.888889 50,22 28,0 Z"/>
        <path d="M 3,3 0,0 h 28 l -1.888889,3 z"/>
        <g>
            {/*<path d="m 23,30.5 c -1.921688,1e-6 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>*/}
            <path d="M 4.499999,28.5 C 2.578312,28.500001 1,26.921689 1,25 c 0,-1.921689 1.578312,-3.500001 3.499999,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 14,8 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 35.556,17.944 c -1.921688,2e-6 -3.5,-1.57831 -3.5,-3.5 0,-1.92169 1.578312,-3.500001 3.5,-3.5 1.921689,-1e-6 3.500001,1.57831 3.5,3.5 1e-6,1.92169 -1.578311,3.500002 -3.5,3.5 z"/>
            <path d="m 45.5,39.5 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 10e-7,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
            <path d="m 25,48.5 c -1.921688,10e-7 -3.5,-1.578311 -3.5,-3.5 0,-1.921689 1.578312,-3.500001 3.5,-3.5 1.921689,-10e-7 3.500001,1.578311 3.5,3.5 1e-6,1.921689 -1.578311,3.500001 -3.5,3.5 z"/>
        </g>
    </>,
    pentagonal_b: <>
        <path d="m 50,0 -3,3 v 44 l 3,3 z"/>
        <path d="M 50,50 H 0 l 3,-3 h 44 z"/>
        <path d="M 0,50 3,47 V 23.888889 L 0,22 Z"/>
        <path d="M 23.888889,3 3,23.888889 0,22 22,0 Z"/>
        <path d="M 47,3 50,0 H 22 l 1.888889,3 z"/>
        <g>
            {/*<path d="m 27,30.5 c 1.921688,1e-6 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-1e-6 -3.500001,1.578311 -3.5,3.5 -1e-6,1.921689 1.578311,3.500001 3.5,3.5 z"/>*/}
            <path d="M 4.5,39.5 C 6.421688,39.500001 8,37.921689 8,36 8,34.078311 6.421688,32.499999 4.5,32.5 2.578311,32.499999 0.999999,34.078311 1,36 c -1e-6,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="m 14.444,17.944 c 1.921688,2e-6 3.5,-1.57831 3.5,-3.5 0,-1.92169 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-1e-6 -3.500001,1.57831 -3.5,3.5 -1e-6,1.92169 1.578311,3.500002 3.5,3.5 z"/>
            <path d="m 36,8 c 1.921688,10e-7 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-1e-6 -3.500001,1.578311 -3.5,3.5 -10e-7,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="M 45.500001,28.5 C 47.421688,28.500001 49,26.921689 49,25 c 0,-1.921689 -1.578312,-3.500001 -3.499999,-3.5 -1.921689,-1e-6 -3.500001,1.578311 -3.5,3.5 -10e-7,1.921689 1.578311,3.500001 3.5,3.5 z"/>
            <path d="m 25,48.5 c 1.921688,10e-7 3.5,-1.578311 3.5,-3.5 0,-1.921689 -1.578312,-3.500001 -3.5,-3.5 -1.921689,-10e-7 -3.500001,1.578311 -3.5,3.5 -1e-6,1.921689 1.578311,3.500001 3.5,3.5 z"/>
        </g>
    </>,
    pentagonal_c: <>
        <path d="M 0,50 3,47 V 3 L 0,0 Z"/>
        <path d="M 0,0 H 50 L 47,3 H 3 Z"/>
        <path d="M 50,0 47,3 V 26.111111 L 50,28 Z"/>
        <path d="M 26.111111,47 47,26.111111 50,28 28,50 Z"/>
        <path d="M 3,47 0,50 H 28 L 26.111111,47 Z"/>
        <g>
            {/*<path d="m 23,19.5 c -1.921688,-1e-6 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,1e-6 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>*/}
            <path d="M 4.499999,21.5 C 2.578312,21.499999 1,23.078311 1,25 c 0,1.921689 1.578312,3.500001 3.499999,3.5 1.921689,1e-6 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 25,1.5 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,10e-7 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 45.5,10.5 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,1e-6 3.500001,-1.578311 3.5,-3.5 10e-7,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
            <path d="m 35.556,32.056 c -1.921688,-2e-6 -3.5,1.57831 -3.5,3.5 0,1.92169 1.578312,3.500001 3.5,3.5 1.921689,1e-6 3.500001,-1.57831 3.5,-3.5 1e-6,-1.92169 -1.578311,-3.500002 -3.5,-3.5 z"/>
            <path d="m 14,42 c -1.921688,-10e-7 -3.5,1.578311 -3.5,3.5 0,1.921689 1.578312,3.500001 3.5,3.5 1.921689,10e-7 3.500001,-1.578311 3.5,-3.5 1e-6,-1.921689 -1.578311,-3.500001 -3.5,-3.5 z"/>
        </g>
    </>,
    pentagonal_d: <>
        <path d="M 50,50 47,47 V 3 l 3,-3 z"/>
        <path d="M 50,0 H 0 l 3,3 h 44 z"/>
        <path d="M 0,0 3,3 V 26.111111 L 0,28 Z"/>
        <path d="M 23.888889,47 3,26.111111 0,28 22,50 Z"/>
        <path d="m 47,47 3,3 H 22 l 1.888889,-3 z"/>
        <g>
            {/*<path d="m 27,19.5 c 1.921688,-1e-6 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,1e-6 -3.500001,-1.578311 -3.5,-3.5 -1e-6,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>*/}
            <path d="m 4.5,10.5 c 1.921688,-10e-7 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,1e-6 -3.500001,-1.578311 -3.5,-3.5 -1e-6,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 25,1.5 c 1.921688,-10e-7 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,10e-7 -3.500001,-1.578311 -3.5,-3.5 -1e-6,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="M 45.500001,21.5 C 47.421688,21.499999 49,23.078311 49,25 c 0,1.921689 -1.578312,3.500001 -3.499999,3.5 -1.921689,1e-6 -3.500001,-1.578311 -3.5,-3.5 -10e-7,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 36,42 c 1.921688,-10e-7 3.5,1.578311 3.5,3.5 0,1.921689 -1.578312,3.500001 -3.5,3.5 -1.921689,10e-7 -3.500001,-1.578311 -3.5,-3.5 -10e-7,-1.921689 1.578311,-3.500001 3.5,-3.5 z"/>
            <path d="m 14.444,32.056 c 1.921688,-2e-6 3.5,1.57831 3.5,3.5 0,1.92169 -1.578312,3.500001 -3.5,3.5 -1.921689,1e-6 -3.500001,-1.57831 -3.5,-3.5 -1e-6,-1.92169 1.578311,-3.500002 3.5,-3.5 z"/>
        </g>
    </>,
}


export const useCanvasCamera = (shape) => {
    const [state, setState] = useState(CAMERA_INI_INDEX)

    const getCameraIndex = () => {
        return state
    }

    const getCameraMapIndex = () => {
        return state +CAMERA_MAP_OFFSET_INDEX
    }

    const setCameraIndex = (cameraIndex) => {
        return setState(cameraIndex)
    }

    const next = () => {
        if ((state + 1) > CAMERA_COUNT[shape]) {
            setCameraIndex(CAMERA_INI_INDEX)
        } else {
            setCameraIndex(getCameraIndex() + 1)
        }
    }

    const getShape = () => {
        return shape
    }

    const getMap = () => {
        return CAMERA_MAP[shape]
    }

    return {
        getCameraIndex, getCameraMapIndex, setCameraIndex, next, getShape, getMap
    }
}